import React, { useContext, useEffect, useState } from "react";
import blogFetch from "../../axios/config";
import Context from "../../context/Context";
import toast from "react-hot-toast";
import { formatNum } from "../../utils/DataUtils";
import { WsEvents, useWebsocket } from "../../context/hooks/WebSocket";
import './style.css';

export default function StatusFurnace() {
    const [statusFurnace, setStatusFurnace] = useState([]);
    const [currentTime, setCurrentTime] = useState(Date.now());

    const {
        furnace,
        getFurnace,
        getHourByFurnace
    } = useContext(Context);

    const ws = useWebsocket();

    useEffect(() => {
        getFurnace();
    }, []);

    useEffect(() => {
        if (furnace.length) {
            getHourFurnace(furnace);

            ws.setHandler(WsEvents.EntryWagon, 'Entry-Wagon', () => getHourFurnace(furnace));
            ws.setHandler(WsEvents.ReleasedWagon, 'Released-Wagon', () => getHourFurnace(furnace));
        }
    }, [furnace]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(Date.now());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (statusFurnace.length)
            setTime(statusFurnace);
    }, [statusFurnace]);

    const getHourFurnace = async (furnace) => {
        const response = await getHourByFurnace(furnace);
        setStatusFurnace(response);
    }

    const setTime = (times) => {
        setTimeout(() => {
            setStatusFurnace(getAllTime(times));
        }, 1000);
    }

    const convertToMinutesANDSeconds = (time) => {
        let days = 0;
        let hours = 0;
        let minutes = Math.floor(time);
        let seconds = Math.round((time - minutes) * 60);

        if (minutes < -1439) {
            days = Math.floor(minutes / 1440);
            hours = Math.floor((minutes % 1440) / 60);
            minutes = Math.abs(minutes % 60);
        } else if (minutes > 1439) {
            days = Math.floor(minutes / 1440);
            hours = Math.floor((minutes % 1440) / 60);
            minutes = Math.abs(minutes % 60);
        } else if (minutes < -59) {
            hours = Math.floor(minutes / 60);
            minutes = Math.abs(minutes % 60);
        }

        const timeArray = [days, hours, minutes, seconds];
        const formattedTimeArray = timeArray.map(num => formatNum(num));
        const timeString = formattedTimeArray.reduce((acc, val, index) => {
            if (val !== '00' || index === timeArray.length - 1) {
                acc.push(val);
            }
            return acc;
        }, []).join(':');

        return timeString;
    }

    const getAllTime = (arrayTimes) => {
        arrayTimes.forEach(({ data: { data } }) => {
            if (data.dateTime) {
                const dataTimes = new Date(data.dateTime);
                data.dateTime = dataTimes;
            }
        })

        return arrayTimes;
    }

    const getTime = (times) => {
        const dataTimes = new Date(times);

        if (!times)
            return "00:00";

        const dataTimesMinutes = (dataTimes - currentTime) / (1000 * 60);

        return convertToMinutesANDSeconds(dataTimesMinutes);
    }

    const getTimeColor = (times) => {
        const dataTimes = new Date(times);
        const dataTimesMinutes = (dataTimes - currentTime) / (1000 * 60);
        switch (true) {
            case dataTimesMinutes <= 5:
                return 'color-time-content-red';
            case dataTimesMinutes > 5 && dataTimesMinutes <= 15:
                return 'color-time-content-orange';
            case dataTimesMinutes > 15 && dataTimesMinutes <= 25:
                return 'color-time-content-yellow';
            case dataTimesMinutes > 25:
                return 'color-time-content-green';
            default:
                return 'color-time-content-red';
        }
    }

    return (
        <>
            {statusFurnace.length
                ? statusFurnace.map(({ data: { data }, forno }, index) => (
                    <div
                        key={`statusFurnace-${index}`}
                        className="d-flex flex-column me-4 mb-2 align-items-center time-content"
                    >
                        <p className="px-4 py-2 m-0 color-time-content-header h2">{forno}</p>
                        <p className={`m-0 ${getTimeColor(data.dateTime)} time-content-stopwatch`}>{getTime(data.dateTime)}</p>
                        <p className="p-2 m-0 color-time-content-header h3">PRÓXIMO</p>
                        <p className="p-0 m-0 next-wagon h1">{data?.wagon ? data?.wagon.vagao_Serial : "N/A"}</p>
                    </div>
                ))
                : <></>}
        </>
    );
}
